import CreditCardList from './CreditCardList';

export default CreditCardList;
